import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { CatlougeTypeConstants } from '../../core/constants';
import { AssetsService } from '../../core/services/assets.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../core';
import { CommonService } from '../../core/services/common.service';
import { ImageManipulationComponent } from '../../core/components/image-manipulation/image-manipulation.component';
import { LoginRegisterComponent } from '../../auth/login-register/login-register.component';
// import { NgIf } from '@angular/common';

@Component({
  selector: 'app-campaign-banner',
  imports: [ImageManipulationComponent, LoginRegisterComponent], //NgIf
  templateUrl: './campaign-banner.component.html',
  styleUrls: ['./campaign-banner.component.css'],
})
export class CampaignBannerComponent {
  catlouge = CatlougeTypeConstants.catlogue;
  @Input() data: any = {};
  landingPage: any;
  episodeDeatil: any;
  imgType: any;
  showImg: any;
  width: string = '';
  bannerWidth: boolean = false;
  public userInfo: any;
  isRedir: boolean = false;
  categoryImage: any;
  thumbnailBannerStretchedLandscape: any;
  thumbnail: any;
  assetImgParam: any;
  videoPlayUrl: any = '';
  player: any;
  current_playing_category_mongo_id: any = '';

  constructor(
    private router: Router,
    public UserService: UserService,
    public AssetsService: AssetsService,
    private modalService: NgbModal,
    public commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.data = this.data;
    // console.log('data',this.data);
    
    this.landingPage = this.data.campaign_banners[0].landing_page;
    this.imgType = this.data.thumbnail_type.slug;
    switch (this.imgType) {
      case 'stretched-landscape':
        this.showImg = this.data.image_stretched_landscape;
        this.bannerWidth = true;
        this.assetImgParam = { crop: 'fill', width: 860, height: 376 };
        break;
      case 'banner':
        this.bannerWidth = false;
        this.showImg = this.data.image_landscape;
        this.assetImgParam = { crop: 'fill' };
        break;
      case 'narrow-landscape':
        this.bannerWidth = false;
        this.showImg = this.data.image_narrow_landscape;
        this.assetImgParam = { crop: 'fill' };
        break;
      case 'panoramic':
        this.bannerWidth = false;
        this.showImg = this.data.campaign_banners[0].image;
        this.assetImgParam = { crop: 'fill' };
        break;
      case 'rectangle':
        this.bannerWidth = false;
        this.showImg = this.data.campaign_banners[0].image;
        this.assetImgParam = { crop: 'fill' };
        break;
      case 'narrow':
        this.bannerWidth = false;
        this.showImg = this.data.campaign_banners[0].image;
        this.assetImgParam = { crop: 'fill' };
        break;
      default:
        this.showImg = this.data.image_landscape;
        this.assetImgParam = { crop: 'fill' };
        break;
    }
  }

  redirectUrl(content: any) {
    this.userInfo = localStorage.getItem('userInfo');
    if(this.player) {
      this.player.dispose();  
    }
    
    if (this.userInfo) {
      switch (this.landingPage) {
        case '__url':
          this.landingUrl();
          break;
        case '__app_page':
          this.landingAppPage();
          break;
        case '__sub_category':
          this.landingSubCategory();
          break;
        case '__asset':
          this.landingAsset();
          break;
        case '__webviewurl':
          this.landingWebUrlPage();
          break;
        case '__tabs':
          this.landingTabPage();
          break;
        case '__category':
          this.landingCategory();
          break;
        default:
          this.router.navigateByUrl('/');
          break;
      }
    } else {
      this.commonService.setBeforeLoginState(this.data);
      // this.router.navigateByUrl('/login');
      this.modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {},
          (reason) => {}
        );
    }
  }

  landingUrl() {
    let url = this.data.campaign_banners[0].url;
    window.open(url, '_blank')!.focus();
  }

  landingAppPage() {
    let appPage = this.data.campaign_banners[0].app_page.toLowerCase();

    switch (appPage) {
      case 'about':
        this.router.navigateByUrl('/aboutus');
        break;
      case 'faq':
        this.router.navigateByUrl('/contactus');
        break;
      case 'help':
        this.router.navigateByUrl('/contactus');
        break;
      case 'my-profile':
        this.router.navigateByUrl('/myaccount');
        break;
      case 'theme-setting':
        this.router.navigateByUrl('/');
        break;
      case 'subscription':
        this.router.navigateByUrl('/subscribe');
        break;
      case 'activation-code':
        this.router.navigateByUrl('/subscribe');
        break;
      case 'watchlist':
        this.router.navigateByUrl('/playlist');
        break;

      default:
        this.router.navigateByUrl('/');
        break;
    }
  }

  // landingSubCategory() {
  //   // if (this.data.sub_category_id) {
  //   //   let input_id = this.data.category_id;
  //   //   let r_url = '/viewall';
  //   //   if (this.data.sub_category_id) {
  //   //     input_id = this.data.category_id;
  //   //     r_url = '/subcategory';
  //   //   }
  //   //   let viewAlldParams:any = {
  //   //     banner: "campaign_banner",
  //   //     sub_category_id: this.data.sub_category_id,
  //   //   }

  //   //   viewAlldParams['type'] = this.data.tab_slug;
  //   //   localStorage.setItem('banner', 'campaign_banner');
  //   //   this.router.navigate([r_url], { queryParams: viewAlldParams })

  //   // } else {
  //   //   let categoryId = this.data.category_id;
  //   //   let viewalltabDataParams = {
  //   //     banner: "campaign_banner",
  //   //     "categoryId": categoryId,
  //   //     "type": 'home'
  //   //   }
  //   //   this.router.navigate(['/subcategory'], { queryParams: viewalltabDataParams })
  //   // }

  //   if (this.data.campaign_banners[0].landing_sub_category_id) {
  //     let input_id = this.data.campaign_banners[0].landing_category_id;
  //     let r_url = '/viewall';
  //     if (this.data.campaign_banners[0].landing_sub_category_id) {
  //       input_id = this.data.campaign_banners[0].landing_category_id;
  //       r_url = '/subcategory';
  //     }
  //     let viewAlldParams:any = {
  //       banner: "campaign_banner",
  //       sub_category_id: this.data.campaign_banners[0].landing_sub_category_id,
  //     }

  //     viewAlldParams['type'] = this.data.campaign_banners[0].landing_tab_slug;
  //     localStorage.setItem('banner', 'campaign_banner');
  //     this.router.navigate([r_url], { queryParams: viewAlldParams })

  //   } else {
  //     let categoryId = this.data.campaign_banners[0].landing_category_id;
  //     let viewalltabDataParams = {
  //       banner: "campaign_banner",
  //       "categoryId": categoryId,
  //       "type": 'home'
  //     }
  //     this.router.navigate(['/subcategory'], { queryParams: viewalltabDataParams })
  //   }
  // }

  landingSubCategory() {
    const bannerData = this.data.campaign_banners[0];
    const routeUrl = '/subcategory';

    const queryParams: any = {
      categoryId: bannerData.landing_sub_category_id,
    };

    this.router.navigate([routeUrl], { queryParams });
  }

  landingAsset() {
    let assetData = this.data.asset;
    this.router.navigate([
      'detail/' +
        this.data.campaign_banners[0].asset.type +
        '/' +
        this.data.campaign_banners[0].asset.code +
        '/' +
        this.data.campaign_banners[0].asset.type,
    ]);
  }

  landingVotingPage() {
    let url = this.data.webviewurl;
    const splitArr = url.split('cid=');
    let eventid = splitArr[1];
    let sessId = localStorage.getItem('sessionId');
    window.open('content/' + eventid + '/' + sessId, '_blank');
  }

  landingTabPage() {
    this.router.navigate([this.data.campaign_banners[0].landing_tab_slug]);
  }

  landingCategory() {
    let categoryId = this.data.campaign_banners[0].landing_category_id;
    this.router.navigate(['viewall'], {
      queryParams: { categoryId: categoryId },
    });
  }

  landingWebUrlPage() {
    const url = this.data.campaign_banners[0].webviewurl;
    if (url) {
      window.open(url, '_blank'); // opens in a new tab
    }
  }

  setCookie(cname: any, cvalue: any, exdays: any) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  playsVideoOnHover(data: any) {
    let id = data.category_mongo_id;
    console.log('data',data);
    
    if (data?.campaign_banners[0]?.view_video_on_hover == '0' || !data?.campaign_banners[0]?.video) return;
    if (this.current_playing_category_mongo_id == id && this.player) {
      console.log('if same banner again');
      
      this.player.currentTime(0);
      this.player.play();
      this.videoPlayUrl = this.player.currentSources()[0];
      return;
    }
    this.current_playing_category_mongo_id = id;
    this.commonService.playVideoOnHover(id).subscribe((res: any) => {
      const playObj = res?.result;
      const videoUrl = playObj?.cloud_front?.video_url;
      this.setCookie(
        'CloudFront-Key-Pair-Id',
        playObj.cloud_front
          ? playObj.cloud_front.cloudfront_key_pair_id.trim()
          : playObj.cloudfront_key_pair_id.trim(),
        1
      );
      this.setCookie(
        'CloudFront-Policy',
        playObj.cloud_front
          ? playObj.cloud_front.cloudfront_policy.trim()
          : playObj.cloudfront_policy.trim(),
        1
      );
      this.setCookie(
        'CloudFront-Signature',
        playObj.cloud_front
          ? playObj.cloud_front.cloudfront_signature.trim()
          : playObj.cloudfront_signature.trim(),
        1
      );

      if (videoUrl) {
        const appendedUrl = `${videoUrl}?wmsAuthSign=${encodeURIComponent(
          playObj.cloud_front.cloudfront_policy
        )}&region=${encodeURIComponent(
          playObj.cloud_front.cloudfront_signature
        )}&package_id=${encodeURIComponent(
          playObj.cloud_front.cloudfront_key_pair_id
        )}`;
        console.log('Appended Video URL:', appendedUrl);

        this.videoPlayUrl = appendedUrl;

        let src_type: any = window.location.hostname === 'localhost' ? 'a' : '';

        if (src_type) {
          this.videoPlayUrl =
            'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4';
        }

        // Initialize or update Video.js player
        const playerId = 'hoverVideo' + this.data.category_mongo_id;
        const videoElement = document.getElementById(playerId);

        if (!videoElement) {
          console.error('Video element not found:', playerId);
          return;
        }
        this.player = videojs.getPlayer(playerId);

        console.log('player', this.player);

        if (!this.player) {
          // initialize if not already
          // player = videojs(playerId, { autoplay: true, muted: true, controls: false, loop: false });

          let new_source = {
            sources: [
              {
                src: this.videoPlayUrl,
                type: src_type ? 'video/mp4' : 'application/x-mpegURL',
              },
            ],
            autoplay: true,
            muted: true,
            controls: false,
            loop: false,
          };
          console.log('playerId', playerId);

          this.player = videojs(playerId, new_source);
          this.player.play();
        }
        console.log('playerId2', playerId);
        // Update source and play
        // player.src({ type: 'application/x-mpegURL', src: appendedUrl });

        this.player.play();
      }
    });
  }

  stopVideoOnHover() {
    if(this.player) {
      this.player.pause();
    }
    
    this.videoPlayUrl = '';
  }
}
